import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Menu } from '../models/menu.model';
import { environment } from '../../../environments/environment';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  private apiUrl = `${environment.apiUrl}/Auth`;

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { }

  getMenus(): Observable<Menu[]> {
    const user = this.authService.getCurrentUser();
    const token = user?.token;

    if (!token) {
      return of([]); // Return empty array if no token is found
    }

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    return this.http.get<Menu[]>(`${this.apiUrl}/GetMenus`, { headers });
  }
} 